const IOS_STORE_URL = 'https://apps.apple.com/app/wennze/id6755939537';
const ANDROID_STORE_URL = 'https://play.google.com/store/apps/details?id=com.wennze.app';
const ANDROID_PACKAGE = 'com.wennze.app';

const getUserAgent = () => (navigator.userAgent || navigator.vendor || window.opera || '');

export const isAndroidDevice = () => /android/i.test(getUserAgent());

export const isIOSDevice = () => /iPad|iPhone|iPod/.test(getUserAgent()) && !window.MSStream;

export const getMobileStoreUrl = () => {
  if (isAndroidDevice()) return ANDROID_STORE_URL;
  if (isIOSDevice()) return IOS_STORE_URL;
  return null;
};

const toAndroidIntentUrl = (deepLink, fallbackUrl) => {
  try {
    // deepLink expected format: wennze://path/segments
    const withoutScheme = deepLink.replace(/^wennze:\/\//i, '');
    const encodedFallback = encodeURIComponent(fallbackUrl);
    return `intent://${withoutScheme}#Intent;scheme=wennze;package=${ANDROID_PACKAGE};S.browser_fallback_url=${encodedFallback};end`;
  } catch {
    return deepLink;
  }
};

/**
 * Attempt to open app and return whether handoff likely succeeded.
 * This uses visibility/blur heuristics because web cannot directly query installed apps.
 */
export const attemptOpenApp = ({ deepLink, webFallbackPath }) => {
  const absoluteFallback = `${window.location.origin}${webFallbackPath}`;

  return new Promise((resolve) => {
    let handoffDetected = false;

    const cleanup = () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.removeEventListener('blur', onBlur);
      window.removeEventListener('pagehide', onPageHide);
    };

    const onVisibilityChange = () => {
      if (document.hidden) {
        handoffDetected = true;
      }
    };

    const onBlur = () => {
      handoffDetected = true;
    };

    const onPageHide = () => {
      handoffDetected = true;
    };

    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('blur', onBlur);
    window.addEventListener('pagehide', onPageHide);

    const timeout = setTimeout(() => {
      cleanup();
      resolve(handoffDetected);
    }, 2200);

    try {
      if (isAndroidDevice()) {
        // Android intent URL provides stronger app-open behavior + browser fallback.
        window.location.href = toAndroidIntentUrl(deepLink, absoluteFallback);
      } else {
        window.location.href = deepLink;
      }
    } catch {
      clearTimeout(timeout);
      cleanup();
      resolve(false);
    }
  });
};

export const MOBILE_STORES = {
  ios: IOS_STORE_URL,
  android: ANDROID_STORE_URL,
};
